module.exports = __webpack_public_path__ + "static/img/home_on.d66bf6bb.svg";